import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type ContainerIsImoResponse = {
  value: boolean;
};

type ContainerIsImoParams = {
  oidVisita: number;
};

export const containerIsImo = async (
  query: ContainerIsImoParams
): Promise<ContainerIsImoResponse['value']> => {
  try {
    const res = await apiClient.post<ContainerIsImoResponse>(
      Endpoints.EsImo,
      query
    );

    return !!res?.data?.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
